<template>
  <div class="dialog-wrap">
    <el-dialog
      title="菜单编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item
          label="菜单标题"
          prop="title"
        >
          <el-input
            v-model="dataForm.title"
            placeholder="请输入菜单标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="副标题"
          prop="subtitle"
        >
          <el-input
            v-model="dataForm.subtitle"
            placeholder="请输入菜单副标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="跳转链接"
          prop="link_url"
        >
          <el-input
            v-model="dataForm.link_url"
            placeholder="请输入跳转链接"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="菜单图标"
          prop="icon"
        >
          <el-upload
            class="cover-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload"
          >
            <img
              v-if="dataForm.icon"
              :src="dataForm.icon"
              class="cover"
            >
            <i
              v-else
              class="el-icon-plus cover-uploader-icon"
            ></i>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="菜单位置"
          prop="position_code"
        >
          <el-select
            v-model="dataForm.position_code"
            placeholder="请选择菜单位置"
            style="width: 100%;"
          >
            <el-option
              v-for="item in positions"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="排序值"
          prop="sort"
        >
          <el-input
            v-model="dataForm.sort"
            placeholder="请输入排序值，纯数字"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="在线状态"
          prop="status"
        >
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { menuUpdate, menuPositionList } from '@/api/operation'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      contentChooseDialog: false,
      dataForm: this.content || {
        icon: ''
      },
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      positions: [],
      rules: {
        title: [{ required: true, message: '请输入菜单标题', trigger: 'blur' }],
        subtitle: [{ required: false, message: '请输入菜单副标题', trigger: 'blur' }],
        link_url: [{ required: true, message: '请输入跳转链接', trigger: 'blur' }],
        icon: [{ required: true, message: '请上传菜单封面', trigger: 'blur' }],
        position_code: [{ required: true, message: '请选择菜单位置', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchPositionList()
      }
    },
    content(val) {
      this.dataForm = val
      this.dataForm.ref_content = this.dataForm.ref_content || {}
    }
  },
  methods: {
    fetchPositionList() {
      menuPositionList({ isPaging: 0 }).then(res => {
        this.positions = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            title: this.dataForm.title,
            link_url: this.dataForm.link_url,
            icon: this.dataForm.icon,
            position_code: this.dataForm.position_code,
            subtitle: this.dataForm.subtitle,
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0
          }
          menuUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.icon = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
  }
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;

    .cover-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .cover-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .cover-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .cover {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
  }
}
</style>
